import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-bg-items-white mx-8 flex flex-col gap-6 px-4 py-8 md:px-10',
    title: 'text-2xl',
    list: 'flex flex-col gap-5',
    itemLink: 'text-m-bold hover:underline hover:underline-offset-4'
  }
});
